module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA3QAAAN0BcFOiBwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACUSURBVFiF7dGxDcIwFITh/1D2oGEQ2IRFKJiDhk1wkRFYgA3Y4GgokFEKCwc3d1Ik50nP/qSTbepI+h6ulM2/HlrKtDA/N95zBLbAA7g2bdr++QMKYKC07g6vIIAAAggggACGAyZJ+5YF26UrALg17qgnYHwFwKGa7YDL+3wC5lUBdaeSnh+/996d1xleQQABBBDAC3hGcDJ1mL7EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t-t.png
// module id = 242
// module chunks = 0